import { CustomSurveyMeasuresByCategory } from './CustomSurveyMeasuresByCategory';

export class MeasureCustomSurveyCategoryGroup {
    id: string;
    customSurveyMeasuresByCategory: CustomSurveyMeasuresByCategory[];
    notes: string;
    collapsed?: boolean;
    customSurveyDate: Date;
    backgroundColor: string;

    // tslint:disable-next-line:max-line-length
    constructor(id: string, customSurveyMeasuresByCategory: CustomSurveyMeasuresByCategory[], notes: string = '', customSurveyDate: Date, backgroundColor: string, collapsed: boolean = true) {
        this.id                             = id;
        this.customSurveyMeasuresByCategory = customSurveyMeasuresByCategory;
        this.notes                          = notes;
        this.collapsed                      = collapsed;
        this.customSurveyDate               = customSurveyDate;
        this.backgroundColor                = backgroundColor;
    }

    public get fontColor(): string {
        return '#000000';
    }

}
